import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import { getReferenceInformationData } from '../../ReferenceInformation/reducer';
import Switches from '../../../components/fields/Switches/Switches';
import { getActionLogData, subjectFormatter } from '../../../utils/formatters';

export default function ApplicationHistoryDialog({ current = null, close = () => {} }) {
  const {
    currentUserActivity = {},
  } = useSelector(getReferenceInformationData);
  const [showData, setShowData] = useState(false);
  const [switchValue, setSwitchValue] = useState(false);
  const columns = [
    {
      dataField: 'name',
      text: 'Имя поля',
      headerClassName: 'field-name-column',
      disableSort: true,
    },
    {
      dataField: 'prev',
      text: 'Данные до изменений',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'new',
      text: 'Данные после изменений',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'current',
      text: 'Текущее значение',
      headerClassName: 'module-column',
      disableSort: true,
    },
  ];

  // Огромный костыль созданный по просьбе Погребца
  const list = getActionLogData(currentUserActivity);
  const gridData = switchValue ? list?.filter(e => e.prev !== e.new) || [] : list || [];
  return (
    <Dialog
      className="registry-history-dialog"
      onClose={close}
      open
    >
      <DialogTitle header="История изменений" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="registry-history-dialog-content">
        <div className="registry-history-dialog-content-title">
          <div>Внесенные изменения</div>
          <Switches
            withLabel
            label="Только изменения"
            inputProps={{
              value: switchValue,
              onChange: () => {
                setSwitchValue(!switchValue);
              },
            }}
            placeholder="Select input placeholder"
            variant="material"
            inverse
          />
        </div>
        <div className="registry-history-table">
          <Grid
            data={gridData}
            columns={columns}
            name="application-list"
          />
        </div>
      </DialogContent>
      <DialogFooter>
        <div className="registry-history-view">
          <div className="registry-view-header" onClick={() => setShowData(!showData)}>
            <div className="registry-view-header-name">Карточка объекта</div>
            <div className={classNames('registry-view-header-button', { show: showData })}>
              {subjectFormatter(currentUserActivity)}
            </div>
          </div>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
